<template>
  <div class="trade-offline-list-view" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" title="团购订单" :showBack="true"></my-header>
    <div class="general-tab-part trade-tab-part">
      <div class="tab-item" @click = "change('')" :class="{'selected':orderOfflineStatus == ''}">全部订单</div>
      <div class="tab-item" @click = "change('1')" :class="{'selected':orderOfflineStatus == '1'}">待支付</div>
      <div class="tab-item" @click = "change('2')" :class="{'selected':orderOfflineStatus == '2'}">已支付</div>
      <div class="tab-item" @click = "change('3')" :class="{'selected':orderOfflineStatus == '3'}">已完成</div>
      <div class="tab-item" @click = "change('4')" :class="{'selected':orderOfflineStatus == '4'}">申请售后</div>
    </div>
    <div class="trade-order-list">
      <div v-if="offlineList.length>0" v-for="item in offlineList" class="customer-cart-item general-box-shadow">
        <div class="shop-info border-bottom-style">
          <div class="shop-name">{{item.shopName}}</div>
          <div v-if="item.status== '6'" class="trade-status status-cancel">{{orderStatusMap[item.status]}}</div>
          <div v-if="item.status== '2' || item.status== '3'" class="trade-status status-deposit">{{orderStatusMap[item.status]}}</div>
          <div v-if="item.status== '1' || item.status== '7'" class="trade-status">{{orderStatusMap[item.status]}}</div>
          <div v-if="item.status== '10' || item.status== '11'" class="trade-status status-refund">{{orderStatusMap[item.status]}}</div>
          <div v-if="item.status== '15'">{{orderStatusMap[item.status]}}</div>
        </div>
        <div class="order-type">订单类型
          <span class="order-type-word" v-if="item.type == '1'">全款订金订单</span>
          <span class="order-type-word" v-if="item.type == '2'">团购订金订单</span>
          <span class="order-type-word" v-if="item.type == '3'">普通订金订单</span>
        </div>
        <div class="order-type" v-if="item.type == '2'||item.type == '3'">支付订金<span>￥{{item.deposit}}</span></div>
        <div class="order-type" v-if="item.type == '1'">支付全款 <span>¥{{item.amount}}</span></div>
        <div v-if="item.type == '1'" class="product-price">总价：<span>¥{{item.amount}}</span></div>
        <div v-if="item.type == '2'||item.type == '3'" class="product-price">总价：<span>￥ {{item.deposit}}</span></div>
        <div class="trade-order-operation">
          <div v-if = "item.status == '1'" class="general-btn" @click = "cancelOffline(item.id)">取消订单</div>
          <div class="general-btn" @click = "toOfflineDetail(item.id)">订单详情</div>
          <div v-if = "item.status == '2'" class="general-btn" @click = "toOfflineRefund(item.id,item.depositTime)">申请退订</div>
          <div v-if = "item.status == '11'" class="general-btn" @click = "toOfflineRefund(item.id,item.depositTime)">再次退订</div>
          <div v-if = "item.status == '2'" class="general-btn pay-tail-btn" @click="uploadPayVoucher(item.id,item.shopName)">上传合同凭证</div>
          <div v-if = "item.status == '1'" class="general-btn pay-btn" @click="payOffline(item.id)">去支付</div>
        </div>
        <div v-if = "item.status == '2'" class="trade-order-operation">
          <div class="general-btn pay-tail-btn" @click="payTailMoney(item.id,item.shopName)">商城支付尾款</div>
        </div>
      </div>
      <div v-if="offlineList.length==0" class="black-page">
          <img src="../../assets/icon-no-img.png">
          <div class="tip">还没有订单哦!</div>
      </div>
    </div>
    <div v-if="isCancelOffline" class="toast general-tip-modal">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="cancel()">
      <div class="general-modal-title border-bottom-style">温馨提示</div>
      <div class="general-modal-msg">您确定要取消订单?</div>
      <div class="agree-btn" @click="confirmCancel()">取消订单</div>
    </div>
    <div v-if="isCancelOffline" class="pay-box"></div>

    <div v-if="isPayOffline" class="toast general-tip-modal">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="cancelPay()">
      <div class="general-modal-title border-bottom-style">温馨提示</div>
      <div class="general-modal-msg">您确定要支付订单?</div>
      <div class="agree-btn" @click="payTraderOffline()">去支付</div>
    </div>
    <div v-if="isPayOffline" class="pay-box"></div>

    <div v-if="isContactService" class="toast general-tip-modal">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="cancelContactService()">
      <div class="general-modal-title border-bottom-style">温馨提示</div>
      <div class="general-modal-msg">您的订单已超过退款期限，<br/>请联系客服进行退款。<br/>客服电话：4000600566</div>
      <div class="agree-btn" @click="contactService()">联系客服</div>
    </div>
    <div v-if="isContactService" class="pay-box"></div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import payUtil from '../../utils/Pay'
  import tradeOfflineService from '../../service/trade/TradeOfflineService'

  export default {
    name: 'TradeOfflineList',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        prePayInfo:{},
        orderOfflineStatus:'',
        offlineList:[],
        pageNo:1,
        orderStatusMap:[],
        isCancelOffline:false,
        isPayOffline:false,
        operationOfflineId:'',
        isWechatBrowser:this.$verfyBrowserType(),
        isContactService:false
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      if (this.global.orderOfflineStatus) {
        this.orderOfflineStatus = this.global.orderOfflineStatus;
        this.global.orderOfflineStatus = '';
      }
      this.loadTradeOfflineList();
    },
    methods: {
      change(status){
        this.orderOfflineStatus = status;
        this.offlineList = [];
        this.loadTradeOfflineList();
      },
      async loadTradeOfflineList(){
        let {code,msg,data} = await tradeOfflineService.list(this.orderOfflineStatus,this.pageNo);
        if(code == '0'){
          this.offlineList = data.offlineList;
          this.orderStatusMap = data.orderStatusMap;
        }else {
          Toast(msg);
        }
      },
      //跳转订单详情
      toOfflineDetail(tradeOfflineId){
        this.global.orderOfflineStatus = this.orderOfflineStatus;
        this.$router.push({name: 'TradeOfflineDetail', query: {tradeOfflineId}})
      },
      //申请退定金
      toOfflineRefund(tradeOfflineId,depositTime){
        var depositDate = new Date(depositTime);
        var now = new Date();
        var day = 24 * 60 * 60 * 1000;
        var diffDay = (now - depositDate) / day;
        if(diffDay.toFixed(0) > 365){
          this.isContactService = true;
        }else {
          this.global.orderOfflineStatus = this.orderOfflineStatus;
          this.$router.push({name: 'OfflineRefund', query: {tradeOfflineId}})
        }
      },
      contactService(){
        window.location.href = "tel:"+4000600566;
      },
      cancelContactService(){
        this.isContactService = false;
      },
      //上传支付凭证
      uploadPayVoucher(tradeOfflineId,shopName){
        this.global.orderOfflineStatus = this.orderOfflineStatus;
        this.$router.push({name: 'OfflinePayVoucher', query: {tradeOfflineId,shopName}})
      },
      //支付尾款
      payTailMoney(tradeOfflineId,shopName){
        this.global.orderOfflineStatus = this.orderOfflineStatus;
        this.$router.push({name: 'OfflineTailMoney', query: {tradeOfflineId,shopName}})
      },
      cancelOffline(id){
        $('#app').css('overflow-y','hidden');
        this.operationOfflineId = id;
        this.isCancelOffline = true;
      },
      cancel(){
        $('#app').css('overflow-y','scroll');
        this.isCancelOffline = false;
      },
      async confirmCancel(){
        tradeOfflineService.cancelOffline(this.operationOfflineId).then(res =>{
          if(res.code == '0'){
             Toast('取消订单成功!');
            this.loadTradeOfflineList();
            this.isCancelOffline = false;
          }else{
            Toast(res.msg);
          }
          $('#app').css('overflow-y','scroll');
        })
      },
      payOffline(id){
        this.operationOfflineId = id;
        this.isPayOffline = true;
      },
      cancelPay(){
        this.isPayOffline = false;
      },
      async payTraderOffline(){
        //判断浏览器类型
        let ua = navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger') {
          let result = await tradeOfflineService.payOffline(this.operationOfflineId,'1');
          if(result.code == '0'){
            this.prePayInfo = payUtil.pay(result.data.prepayId,result.data.nonceStr);
            let requestPay = this.requestPay;
            if (typeof WeixinJSBridge == "undefined"){
              if( document.addEventListener ){
                document.addEventListener('WeixinJSBridgeReady', requestPay, false);
              }else if (document.attachEvent){
                document.attachEvent('WeixinJSBridgeReady', requestPay);
                document.attachEvent('onWeixinJSBridgeReady', requestPay);
              }
            }else{
              this.requestPay();
            }
          } else {
            Toast(result.msg);
          }
        }else {
          let result = await tradeOfflineService.payOffline(this.operationOfflineId);
          if(result.code == '0'){
            let payCallBackUrl = result.data.mwebUrl + '&redirect_url=' + window.location.href;
            window.location.href = payCallBackUrl;
          }else {
            Toast(result.msg);
          }
        }
      },
      requestPay(){
        let prePayInfo = this.prePayInfo;
        let that = this;
        try {
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            {
              "appId":prePayInfo.appId,     //公众号名称，由商户传入
              "timeStamp":prePayInfo.timeStamp,         //时间戳，自1970年以来的秒数
              "nonceStr":prePayInfo.nonceStr, //随机串
              "package":prePayInfo.package,
              "signType":prePayInfo.signType,         //微信签名方式：
              "paySign":prePayInfo.paySign //微信签名
            },
            function(res){
              if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                that.loadTradeOfflineList();
                that.isPayOffline = false;
              } else if(res.err_msg == "get_brand_wcpay_request:cancel" ){
                console.info("取消支付");
              }else {
                that.isPayOffline = false;
                Toast('支付失败!');
              }// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
            },function (e) {
              console.error("支付失败err!"+JSON.stringify(e));
              Toast("支付失败!"+JSON.stringify(e));
            });
        }catch (e){
          console.error("支付失败-----!"+JSON.stringify(e));
          Toast("支付失败!"+JSON.stringify(e));
        }
      },
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .trade-offline-list-view {
    font-size: 0.32rem;
    background-color: white;
    .trade-tab-part{
      position: fixed;
      height: 0.9rem;
      width: 100%;
      line-height: 0.9rem;
      background: white;
      font-size: 0.32rem;
      z-index: 1;
      .selected{
        font-size: 0.36rem;
        font-weight: bold
      }
    }
    .trade-order-list{
      padding-top: 1rem;
      overflow-y: scroll;
      flex-grow: 1
    }
    .shop-info{
      width: 6.3rem;
      line-height: 0.9rem;
      display: flex;
      justify-content: space-between;
      margin: 0 0.3rem 0.3rem 0.3rem;
      .shop-name{
        font-size: 0.32rem;
        color: #7f7d7c;
      }
      .trade-status{
        color: #feac00;
      }
      .status-deposit{
        color: #70c285;
      }
      .status-refund{
        color: #d54a33;
      }
      .status-cancel{
        color: #cecbca;
      }
    }
    .customer-cart-item{
      width: 6.9rem;
      margin: 0.2rem 0.3rem 0.22rem;
      padding-bottom: 0.3rem;
      .product-price{
        margin-right: 0.3rem;
        margin-bottom: 0.6rem;
        text-align: right;
        height: 0.7rem;
        line-height: 0.7rem;
        font-size: 0.28rem;
      }
      .product-price span{
        font-size: 0.4rem;
        color: #d54a33;
      }
      .trade-order-operation{
        font-size: 0.28rem;
        margin-right: 0.3rem;
        margin-bottom: 0.3rem;
        display: flex;
        justify-content: flex-end;
        .general-btn{
          font-size: 0.32rem;
          margin-left: 0.2rem;
        }
        .pay-tail-btn{
          width: 2.24rem;
          border: solid 0;
          background-color: #feac00;
          color: white;
        }
      }
    }
    .order-type{
      font-size: 0.28rem;
      color: #7f7d7c;
      margin-left: 0.3rem;
      margin-bottom: 0.1rem;
      .order-type-word{
         font-size: 0.32rem;
         color: #191818;
      }
    }
    .order-type span{
      margin-left: 0.15rem;
       font-size: 0.4rem;
       color: #d54a33;
    }
  }
</style>
